
export default function Rateios() {
  return (
    <div>Rateios</div>
  )
}
